export const SDK_VERSION = '8.11.0';
